
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1609846050943",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1971",
    "data-darkreader-inline-fill": "",
    "width": "64",
    "height": "64"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M557.568 383.36m0 47.232l0 178.88q0 47.232-47.232 47.232l0.064 0q-47.232 0-47.232-47.232l0-178.88q0-47.232 47.232-47.232l-0.064 0q47.232 0 47.232 47.232Z",
        "p-id": "1972",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M510.4 176.512l298.944 71.744v302.208a335.168 335.168 0 0 1-11.456 89.6 262.976 262.976 0 0 1-29.12 67.328 296.512 296.512 0 0 1-93.824 93.248 452.864 452.864 0 0 1-108.8 50.176 482.816 482.816 0 0 1-55.744 14.144 483.648 483.648 0 0 1-55.744-14.144 452.736 452.736 0 0 1-108.8-50.176 296.384 296.384 0 0 1-93.824-93.248 264.064 264.064 0 0 1-29.12-67.328 335.808 335.808 0 0 1-11.392-89.6V248.256l298.944-71.744m0-96a32 32 0 0 0-7.36 0.896L141.248 168.256a31.424 31.424 0 0 0-24.128 30.592v352c0 339.2 344.064 402.624 388.608 409.6a32 32 0 0 0 4.736 0.384 32 32 0 0 0 4.736-0.384c44.8-6.784 388.608-70.016 388.608-409.6v-352a31.488 31.488 0 0 0-24.128-30.592L517.824 81.408a31.488 31.488 0 0 0-7.36-0.896z",
        "p-id": "1973",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    }
  ]
})
    }
  